<!-- casino1 -->
<div class="lvc-thumb" *ngIf="events.casino1.includes(id) && data && data?.event_types.length > 0">
    <div class="row">
        <h2 *ngIf="!isDashboard">live casino</h2>
        <!-- aura lobby static -->
        <div class="col-md-2 col-6">
          <img class="img-fluid" [lazyLoad]="'https://speedcdn.io/assets/parker-client/casinogames/aura-gaming-lobby.webp'" (click)="confirmCasinoDetail(99999, 99999)" alt="aura_lobby" title="Aura Lobby">
        </div>
        <div class="col-md-2 col-6" (click)="confirmLogin(item)" *ngFor="let item of data?.event_types;trackBy:trackByIndex;">
            <!-- <img class="img-fluid" src="assets/img/casino-id/{{item?.id}}.png" alt="{{item?.name}}" title="{{item?.name}}"> -->
            <img class="img-fluid" [lazyLoad]="getImagePath(item)" alt="{{item.name}}" title="{{item?.name}}">
            <!-- <span>({{item?.id}} - {{item?.name}})</span> -->
        </div>
    </div>
    <app-loader class="no-overlay" *ngIf="isLoad && router.url.includes('/casino')  "></app-loader>
</div>

<!-- i-casino -->
<div class="int-casino-content position-relative" *ngIf="events.iCasino.includes(id)">
    <div class="lvc-thumb">
        <h2>I Casino</h2>
        <!-- <div class="dropdown viewby-filter">
            <button type="button" id="ViewBy" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="dropdown-toggle">
                <i class="mdi mdi-filter"></i> View by </button>
            <div aria-bs-labelledby="ViewBy" class="dropdown-menu" style="">
                <a href="javascript:void(0)">Competition</a>
                <a href="javascript:void(0)" class="active">Time</a>
            </div>
        </div> -->
    </div>
    <div class="tab-container">
        <div class="market_section tabcasino">
            <div class="fancyTabs" *ngIf="data">
                <!-- <div *ngFor="let tabDt of data.tables;trackBy:trackByIndex;"> -->
                    
                    <!-- old icasino -->
                    
                    <!-- <tabset class="casino_tabs_ul">
                    <tab [heading]="'1 To ' + tabDt.name" *ngFor="let tabDt of data.tables;trackBy:trackByIndex;">
                        <div class="icasino_ul_tabs">
                            <tabset>
                                <tab id="tab1" *ngFor="let innerTabDt of tabDt.data;let j=index;trackBy:trackByIndex;" (selectTab)="onSelect(j)">
                                    <ng-template tabHeading>
                                        {{innerTabDt.name}}
                                    </ng-template>
                                    <div class="intcasino-sub-tab">
                                        <div class="row py-2 mx-0" *ngIf="tabId == j">
                                            <div class="col-md-2 col-4" (click)="confirmBox(item, tabDt.name)" *ngFor="let item of innerTabDt.data;trackBy:trackByIndex;">
                                                <div class="casino-images-box position-relative">
                                                    <img class="img-fluid" [lazyLoad]="item.url_thumb ? item.url_thumb : item.image_path" alt="{{item.name}}">
                                                    <a href="javascript:void(0)" class="btn casino-btn">Play Now</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </tab>
                            </tabset>        
                        </div>
                    </tab>
                    </tabset> -->

                <!-- </div> -->

                <!-- new icasino -->
                <tabset class="casino_tabs_ul" #parentTabs>
                    <tab *ngFor="let tabDt of data;let i=index;trackBy:trackByIndex;" (selectTab)="onSelectParent(i)">
                        <ng-template tabHeading>
                            <!-- {{tabDt?.name | uppercase}} -->
                            {{tabDt?.name.charAt(0).toUpperCase() + tabDt?.name.slice(1)}}
                            <!-- <img class="img-fluid" src="assets/img/icon/{{tabDt?.slug}}.png"> -->
                        </ng-template>
                        <div class="icasino_ul_tabs">
                            <tabset #childTabs>
                                <tab id="tab1" *ngFor="let innerTabDt of tabDt.data;let j=index;trackBy:trackByIndex;" (selectTab)="onSelect(j)">
                                    <ng-template tabHeading>
                                        <img class="img-fluid tab-image" src="https://speedcdn.io/assets/int_tab_icons/{{innerTabDt?.slug}}.png">
                                        <!-- {{innerTabDt?.name | uppercase}} -->
                                        {{innerTabDt?.name.charAt(0).toUpperCase() + innerTabDt?.name.slice(1)}}
                                    </ng-template>
                                    <div class="intcasino-sub-tab">
                                        <div class="row py-2 mx-0" *ngIf="tabId == j">
                                            <div class="col-md-2 col-4" (click)="confirmBox(item, tabDt.name)" *ngFor="let item of innerTabDt.data;trackBy:trackByIndex;">
                                                <div class="casino-images-box position-relative">
                                                    <img class="img-fluid" [lazyLoad]="item.url_thumb ? item.url_thumb : item.image_path" alt="{{item.name}}">
                                                    <a href="javascript:void(0)" class="btn casino-btn">Play Now</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </tab>
                            </tabset>
                        </div>
                    </tab>
                </tabset>

            </div>
        </div>
    </div>
    <app-loader class="no-overlay" *ngIf="isLoad"></app-loader>
</div>


<!-- Int Casino -->
<div class="int-casino-content position-relative" *ngIf="events.intCasino.includes(id)">
    <div class="lvc-thumb">
        <h2>Int Casino</h2>
        <!-- <div class="dropdown viewby-filter">
            <button type="button" id="ViewBy" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="dropdown-toggle">
                <i class="mdi mdi-filter"></i> View by </button>
            <div aria-bs-labelledby="ViewBy" class="dropdown-menu" style="">
                <a href="javascript:void(0)">Competition</a>
                <a href="javascript:void(0)" class="active">Time</a>
            </div>
        </div> -->
    </div>
    <!-- <div class="events-title-main">
        <h2 class=""> Int Casino </h2>
        <div class="dropdown viewby-filter">
            <button type="button" id="ViewBy" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="dropdown-toggle">
                <i class="mdi mdi-filter"></i> View by </button>
            <div aria-bs-labelledby="ViewBy" class="dropdown-menu" style="">
                <a href="javascript:void(0)">Competition</a>
                <a href="javascript:void(0)" class="active">Time</a>
            </div>
        </div>
    </div> -->
    <div class="tab-container">
        <div class="market_section tabcasino">
            <div class="fancyTabs">
                <tabset #parentTabs class="casino_tabs_ul">
                    <tab *ngFor="let tabDt of data;let i=index;trackBy:trackByIndex;" (selectTab)="onSelectParent(i)">
                        <ng-template tabHeading>
                            {{tabDt?.name}}
                            <!-- <img class="img-fluid" src="assets/img/icon/{{tabDt?.slug}}.png"> -->
                        </ng-template>
                        <div class="icasino_ul_tabs">
                            <tabset>
                                <tab id="tab1" *ngFor="let innerTabDt of tabDt.data;let j=index;trackBy:trackByIndex;" (selectTab)="onSelect(j)">
                                    <ng-template tabHeading>
                                        <img class="img-fluid" src="https://speedcdn.io/assets/int_tab_icons/{{innerTabDt?.slug}}.png">
                                        {{innerTabDt.name}}
                                    </ng-template>
                                    <div class="intcasino-sub-tab">
                                        <div class="row py-2 mx-0" *ngIf="tabId == j">
                                            <div class="col-md-2 col-4" (click)="confirmBox(item, tabDt.name)" *ngFor="let item of innerTabDt.data;trackBy:trackByIndex;">
                                                <div class="casino-images-box position-relative">
                                                    <img class="img-fluid" [lazyLoad]="item.url_thumb ? item.url_thumb : item.image_path" alt="{{item.name}}">
                                                    <a href="javascript:void(0)" class="btn casino-btn">Play Now</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </tab>
                            </tabset>
                        </div>
                    </tab>
                </tabset>
            </div>
        </div>
    </div>
    <app-loader class="no-overlay" *ngIf="isLoad"></app-loader>
</div>
<!--/ Int Casino End -->